// const initialState = {
//   open: false,
//   current: 'Dashboard',
// };

function navBarReducer(state = { open: false,authStatus:'authorized' }, action) {
  switch (action.type) {
    case 'OPEN_SIDEBAR':
      // state.open = true;
      // state.open = action.payload.open;
      return Object.assign({}, (state = { open: true }));
    case 'CLOSE_SIDEBAR':
      return Object.assign({}, (state = { open: false }));
    case 'CURRENT_STATE_CHANGE':
      return Object.assign({}, (state = action.payload));
    case 'REDIRECT_TO_LOGIN':
      return Object.assign({}, (state = {authStatus:'unAuthorized'}));
    default:
      return state;
  }
}

export default navBarReducer;
